const enumeraciones = {};

enumeraciones.google = {
    proveedor: "google", 
    llave: "AIzaSyDkjlBpVAzCC_5EgErARWBYXMAafcx3QCI"
}

export default enumeraciones;


//////////////////
// WEBPACK FOOTER
// ./static/js/enumeraciones/devextreme.js
// module id = null
// module chunks = 